export interface ComboboxColumnDefinition {
    class?: string;
    field: string;
    title: string;
    width: number;
}